<div class="tenders-card shadow-sm">
  <div class="table-responsive">
    <table class="table tenders-table mb-0 align-middle">
      <thead>
        <tr>
          <th class="ps-4">
            <a (click)="sort($event, 'location')" class="pointer d-flex align-items-center text-muted">Location
              <ng-icon *ngIf="orderField === 'location' && order"
                [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
              </ng-icon>
            </a>
          </th>
          <th *ngIf="!tender.company.settings.isHiddenField('location_company')">
            <a (click)="sort($event, 'company')" class="pointer d-flex align-items-center text-muted">Company
              <ng-icon *ngIf="orderField === 'company' && order"
                [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
              </ng-icon>
            </a>
          </th>
          <th *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')">
            <a (click)="sort($event, 'fuel_type')" class="pointer d-flex align-items-center text-muted">Fuel Type
              <ng-icon *ngIf="orderField === 'fuel_type' && order"
                [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
              </ng-icon>
            </a>
          </th>
          <th *ngIf="!tender.company.settings.isHiddenField('location_flight_type')">
            <a (click)="sort($event, 'flight_type')" class="pointer d-flex align-items-center text-muted">Flight Type
              <ng-icon *ngIf="orderField === 'flight_type' && order"
                [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
              </ng-icon>
            </a>
          </th>
          <th *ngIf="!tender.company.settings.isHiddenField('location_delivery_point')">
            Delivery Point
          </th>
          <th>
            <a (click)="sort($event, 'volume')" class="pointer d-flex align-items-center text-muted">Yearly Volume
              <ng-icon *ngIf="orderField === 'volume' && order"
                [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
              </ng-icon>
            </a>
          </th>
          <th>
            Tags
          </th>
          <!-- Round column removed as requested -->
          <th class="text-center">
            <a (click)="sort($event, 'status')"
              class="pointer d-flex align-items-center justify-content-center text-muted">Status
              <ng-icon *ngIf="orderField === 'status' && order"
                [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
              </ng-icon>
            </a>
          </th>
          <th class="text-center">
            <a (click)="sort($event, 'bids_count')"
              class="pointer d-flex align-items-center justify-content-center text-muted"
              ngbTooltip="Total number of bids submitted in current round (filtered). Click to sort." placement="top"
              container="body">
              Bids <span>({{ filteredBidsCount | number:'1.0-0' | usNumber }})</span>
              <ng-icon *ngIf="orderField === 'bids_count' && order"
                [name]="order === 'ASC' ? 'lucideChevronUp' : 'lucideChevronDown'" class="ms-1">
              </ng-icon>
            </a>
          </th>
          <th>
            Settings
          </th>
          <th class="pe-4">
            <div class="th"></div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor='let contract of contracts'>
          <td class="ps-4">
            <div class="td d-flex align-items-center">
              <strong ngbTooltip="{{ contract.location.name }}" placement="right" container="body">{{
                contract.location.iata }}</strong>
            </div>
          </td>
          <td *ngIf="!tender.company.settings.isHiddenField('location_company')" data-label="Company">
            <span *ngIf="contract.companyChild && contract.companyChild?.name">{{
              contract.companyChild?.getDisplayName() }}</span>
            <span *ngIf="!(contract.companyChild && contract.companyChild?.name)">{{ contract.companyInfo }}</span>
          </td>
          <td *ngIf="!tender.company.settings.isHiddenField('location_fuel_type')" data-label="Fuel Type">
            <span *ngIf="contract.fuelType?.name">{{tender.company.settings.getFilteredOptionLabel('fuel_type',
              contract.fuelType)}}</span>
            <span *ngIf="!contract.fuelType?.name" class="small text-muted">
              Not Provided
            </span>
          </td>
          <td *ngIf="!tender.company.settings.isHiddenField('location_flight_type')" data-label="Flight Type">
            <span *ngIf="contract.flightType?.name">{{contract.flightType.name}}</span>
          </td>
          <td *ngIf="!tender.company.settings.isHiddenField('location_delivery_point')" data-label="Delivery Point">
            <span
              *ngIf="contract.fuelPreference?.name">{{tender.company.settings.getFilteredOptionLabel('delivery_point',
              contract.fuelPreference)}}</span>
          </td>
          <td data-label="Yearly Volume">
            {{ contract.volume | number : '1.0-0' | usNumber }}
          </td>
          <td data-label="Tags">
            <span *ngFor="let tag of contract.tags">
              <span
                class="badge py-1 px-2 me-2 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill">
                {{tag['name']}}
              </span>
            </span>
          </td>
          <!-- Round column removed -->
          <td class="text-center" data-label="Status">
            <jft-round-status [status]="contract.currentRound.status"></jft-round-status>
            <div class="small text-muted mt-1">
              <jft-time-remaining [round]="contract.currentRound"></jft-time-remaining>
            </div>
          </td>
          <td class="text-center" data-label="Bids">
            {{contract.currentRound.bidsSubmitted}}
          </td>
          <td data-label="Settings">
            <ng-template #tipContent>
              <div class="text-start">

                <div *ngIf="contract.dateStart">
                  Contract start date: <strong>{{contract.dateStart | date:'dd MMM yyyy':'UTC'}}</strong><br>
                </div>
                <div *ngIf="contract.dateEnd">
                  Contract end date: <strong>{{contract.dateEnd | date:'dd MMM yyyy':'UTC'}}</strong><br>
                </div>
                <div *ngIf="contract.currency?.code">
                  Preferred currency: <strong>{{contract.currency.code}}</strong><br>
                </div>
                <div *ngIf="contract.units?.code">
                  Preferred units: <strong>{{contract.units.code}}</strong><br><br>
                </div>

                <div
                  *ngIf="!tender.company.settings.isHiddenField('location_annual_frequency') && contract.annualFrequency">
                  Annual Frequency: <strong>{{contract.annualFrequency}}</strong><br>
                </div>
                <div
                  *ngIf="!tender.company.settings.isHiddenField('location_average_uplift') && contract.averageUplift">
                  Average uplift: <strong>{{contract.averageUplift}}</strong><br>
                </div>
                <div
                  *ngIf="!tender.company.settings.isHiddenField('location_months_of_service') && contract.monthService">
                  Months of service: <strong>{{contract.monthService}}</strong><br>
                </div>
                <div
                  *ngIf="!tender.company.settings.isHiddenField('location_monthly_volume') && contract.monthService && contract.volume">
                  Monthly volume: <strong>{{contract.volume / contract.monthService | number : '1.0-0' | usNumber }} {{
                    contract.units.code }}</strong><br>
                </div>
                <div *ngIf="!tender.company.settings.isHiddenField('location_award_quota') && contract.awardQuota">
                  Award quota: <strong>{{ contract.awardQuota }}%</strong><br>
                </div>
                <div *ngIf="!tender.company.settings.isHiddenField('location_branded')">
                  Branded: <strong>{{ contract.branded ? 'Yes' : 'No' }}</strong><br>
                </div>

                <div *ngIf="!tender.company.settings.isHiddenField('location_notes') && contract.notes">
                  <br>
                  Location Specific Notes:<br>{{contract.notes}}<br>
                </div>
              </div>
            </ng-template>
            <a href="javascript:void(0);" placement="left" [ngbTooltip]="tipContent">
              <i class="fas fa-sliders-h"></i>
            </a>
          </td>
          <td class="text-end pe-4 mobile-full">
            <div *ngIf="user.canManageAdvanced(tender) && !user.isAnyRestricted()" ngbDropdown class="d-inline-block">
              <button type="button" class="btn btn-light btn-sm me-2" id="dropdownBasic1" ngbDropdownToggle>
                Options
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                <a *ngIf="contract.currentRound.status !== roundStatuses.CANCELLED" ngbDropdownItem
                  class="pointer text-dark" (click)="editLocation(contract)">Edit
                  Location</a>
                <a *ngIf="contract.currentRound.status !== roundStatuses.CANCELLED" ngbDropdownItem
                  class="pointer text-dark" (click)="showCancelConfirmation(contract)">Cancel Location</a>
                <a *ngIf="contract.currentRound.status == roundStatuses.CANCELLED" ngbDropdownItem
                  class="pointer text-danger" (click)="showDeleteConfirmation(contract)">Delete Location</a>
              </div>
            </div>
            <ng-container>
              <!-- Dashboard View links-->
              <ng-container *ngIf="tender.company.settings.isSealedTender()">
                <a *ngIf="contract.currentRound.round > 1" class="btn btn-light btn-sm me-2"
                  [routerLink]="['/tenders', tender.id, 'locations', contract.id, 'dashboard', 'round', contract.currentRound.isClosed ? contract.currentRound.round : contract.currentRound.round - 1]"
                  placement="left" ngbTooltip="Go to Dashboard View">
                  <svg class="svg-fill-dark" width="24px" height="24px" viewBox="0 0 1920 1920"
                    xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M0 612.001h425V187H0v425.001Zm640-105h1280v-225H640v225Zm-640 665h425v-425H0v425Zm640-100h1280v-225H640v225Zm-640 660h425v-425H0v425Zm640-97h1280v-225H640v225Z"
                        fill-rule="evenodd"></path>
                    </g>
                  </svg>
                </a>
                <a *ngIf="contract.currentRound.round == 1"
                  [routerLink]="contract.currentRound.isClosed ? ['/tenders', tender.id, 'locations', contract.id, 'dashboard', 'round', contract.currentRound.round] : null"
                  class="btn btn-light btn-sm me-2" placement="left"
                  [ngbTooltip]="contract.currentRound.isClosed ? 'Go to Dashboard View' : 'Dashboard View is not available for sealed tenders during active rounds.'">
                  <svg class="svg-fill-dark" width="24px" height="24px" viewBox="0 0 1920 1920"
                    xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M0 612.001h425V187H0v425.001Zm640-105h1280v-225H640v225Zm-640 665h425v-425H0v425Zm640-100h1280v-225H640v225Zm-640 660h425v-425H0v425Zm640-97h1280v-225H640v225Z"
                        fill-rule="evenodd"></path>
                    </g>
                  </svg>
                </a>
              </ng-container>
              <a *ngIf="!tender.company.settings.isSealedTender()" class="btn btn-light btn-sm me-2"
                [routerLink]="['/tenders', tender.id, 'locations', contract.id, 'dashboard', 'round', contract.currentRound.round]"
                placement="left" ngbTooltip="Go to Dashboard View">
                <svg class="svg-fill-dark" width="24px" height="24px" viewBox="0 0 1920 1920"
                  xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M0 612.001h425V187H0v425.001Zm640-105h1280v-225H640v225Zm-640 665h425v-425H0v425Zm640-100h1280v-225H640v225Zm-640 660h425v-425H0v425Zm640-97h1280v-225H640v225Z"
                      fill-rule="evenodd"></path>
                  </g>
                </svg>
              </a>
              <!-- Dashboard View links end-->
              <!-- Analysis View links-->
              <ng-container *ngIf="tender.company.settings.isSealedTender()">
                <a *ngIf="contract.currentRound.round > 1" class="btn btn-light btn-sm"
                  [routerLink]="['/tenders', tender.id, 'locations', contract.id, 'dashboard', 'analysis', 'round', contract.currentRound.isClosed ? contract.currentRound.round : contract.currentRound.round - 1]"
                  placement="left" ngbTooltip="Go to Analysis View">
                  <svg class="svg-fill-dark" width="24px" height="24px" viewBox="0 0 1920 1920"
                    xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M746.667 106.667H1173.33V1493.33H746.667V106.667ZM533.333 533.333H106.667V1493.33H533.333V533.333ZM1920 1706.67H0V1824H1920V1706.67ZM1813.33 746.667H1386.67V1493.33H1813.33V746.667Z">
                      </path>
                    </g>
                  </svg>
                </a>
                <a *ngIf="contract.currentRound.round == 1"
                  [routerLink]="contract.currentRound.isClosed ? ['/tenders', tender.id, 'locations', contract.id, 'dashboard', 'analysis', 'round', contract.currentRound.round] : null"
                  class="btn btn-light btn-sm" placement="left"
                  [ngbTooltip]="contract.currentRound.isClosed ? 'Go to Analysis View' : 'Analysis View is not available for sealed tenders during active rounds.'">
                  <svg class="svg-fill-dark" width="24px" height="24px" viewBox="0 0 1920 1920"
                    xmlns="http://www.w3.org/2000/svg">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M746.667 106.667H1173.33V1493.33H746.667V106.667ZM533.333 533.333H106.667V1493.33H533.333V533.333ZM1920 1706.67H0V1824H1920V1706.67ZM1813.33 746.667H1386.67V1493.33H1813.33V746.667Z">
                      </path>
                    </g>
                  </svg>
                </a>
              </ng-container>
              <a *ngIf="!tender.company.settings.isSealedTender()" class="btn btn-light btn-sm"
                [routerLink]="['/tenders', tender.id, 'locations', contract.id, 'dashboard', 'analysis', 'round', contract.currentRound.round]"
                placement="left" ngbTooltip="Go to Analysis View">
                <svg class="svg-fill-dark" width="24px" height="24px" viewBox="0 0 1920 1920"
                  xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                  <g id="SVGRepo_iconCarrier">
                    <path
                      d="M746.667 106.667H1173.33V1493.33H746.667V106.667ZM533.333 533.333H106.667V1493.33H533.333V533.333ZM1920 1706.67H0V1824H1920V1706.67ZM1813.33 746.667H1386.67V1493.33H1813.33V746.667Z">
                    </path>
                  </g>
                </svg>
              </a>
            </ng-container>
          </td>
        </tr>
        <!-- Empty state -->
        <tr *ngIf="!contracts.length && !loading" class="mobile-plain">
          <td colspan="10">
            <p class="text-center small my-5">No locations found</p>
          </td>
        </tr>

        <!-- Loading placeholders -->
        <tr *ngIf="loading" class="placeholder-glow mobile-plain">
          <td><span class="placeholder col-2"></span></td>
          <td><span class="placeholder col-8"></span></td>
          <td><span class="placeholder col-6"></span></td>
          <td><span class="placeholder col-5"></span></td>
          <td><span class="placeholder col-7"></span></td>
          <td><span class="placeholder col-4"></span></td>
          <td><span class="placeholder col-6"></span></td>
          <td><span class="placeholder col-5"></span></td>
          <td><span class="placeholder col-3"></span></td>
          <td><span class="placeholder col-4"></span></td>
        </tr>
        <tr *ngIf="loading" class="placeholder-glow mobile-plain">
          <td><span class="placeholder col-2"></span></td>
          <td><span class="placeholder col-7"></span></td>
          <td><span class="placeholder col-5"></span></td>
          <td><span class="placeholder col-6"></span></td>
          <td><span class="placeholder col-8"></span></td>
          <td><span class="placeholder col-4"></span></td>
          <td><span class="placeholder col-5"></span></td>
          <td><span class="placeholder col-6"></span></td>
          <td><span class="placeholder col-3"></span></td>
          <td><span class="placeholder col-4"></span></td>
        </tr>
        <tr *ngIf="loading" class="placeholder-glow mobile-plain">
          <td><span class="placeholder col-2"></span></td>
          <td><span class="placeholder col-9"></span></td>
          <td><span class="placeholder col-4"></span></td>
          <td><span class="placeholder col-7"></span></td>
          <td><span class="placeholder col-6"></span></td>
          <td><span class="placeholder col-4"></span></td>
          <td><span class="placeholder col-7"></span></td>
          <td><span class="placeholder col-5"></span></td>
          <td><span class="placeholder col-3"></span></td>
          <td><span class="placeholder col-4"></span></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Pagination Controls -->
<div class="text-center p-3 border-top bg-light" *ngIf="totalItems > 0 && showingCount < totalItems">
  <button class="btn btn-primary px-4" (click)="loadMore()" [disabled]="loading">
    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    Load More
    <small class="ms-1 op-50">({{ showingCount }} of {{ totalItems }})</small>
  </button>
</div>

<!-- Cancel Location Confirmation Modal -->
<ng-template #cancelLocationModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Cancel Location</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <!-- Warning for awarded locations -->
    <div *ngIf="contractToCancel?.currentRound?.status === roundStatuses.AWARDED" class="alert alert-warning mb-3">
      <h6 class="alert-heading"><i class="fas fa-exclamation-triangle me-2"></i>Cannot Cancel Awarded Location</h6>
      <p class="mb-0">This location has already been awarded and cannot be cancelled directly. You must first withdraw
        the award before cancelling the location.</p>
    </div>

    <!-- Normal cancellation warning for non-awarded locations -->
    <div *ngIf="contractToCancel?.currentRound?.status !== roundStatuses.AWARDED">
      <p class="mb-3"><strong>Attention! This actions can not be undone.</strong></p>
      <p>Suppliers will receive a location cancellation notification and the tender for this location will be cancelled.
      </p>
    </div>

    <div *ngIf="contractToCancel" class="border rounded p-3 bg-light">
      <h6 class="mb-2">Location Details:</h6>
      <div><strong>Location:</strong> {{contractToCancel.location.iata}} - {{contractToCancel.location.name}}</div>

      <div *ngIf="contractToCancel.volume && contractToCancel.units?.code">
        <strong>Volume:</strong> {{contractToCancel.volume | number : '1.0-0' | usNumber}}
        {{contractToCancel.units.code}}
      </div>

      <div *ngIf="!tender.company.settings.isHiddenField('location_company') && contractToCancel.companyInfo">
        <strong>Company: </strong>
        <span *ngIf="contractToCancel.companyChild && contractToCancel.companyChild?.name">{{
          contractToCancel.companyChild?.getDisplayName() }}</span>
        <span *ngIf="!(contractToCancel.companyChild && contractToCancel.companyChild?.name)">{{
          contractToCancel.companyInfo }}</span>
      </div>

      <div *ngIf="!tender.company.settings.isHiddenField('location_fuel_type') && contractToCancel.fuelType?.name">
        <strong>Fuel Type:</strong> {{tender.company.settings.getFilteredOptionLabel('fuel_type',
        contractToCancel.fuelType)}}
      </div>

      <div *ngIf="!tender.company.settings.isHiddenField('location_flight_type') && contractToCancel.flightType?.name">
        <strong>Flight Type:</strong> {{contractToCancel.flightType.name}}
      </div>

      <div
        *ngIf="!tender.company.settings.isHiddenField('location_delivery_point') && contractToCancel.fuelPreference?.name">
        <strong>Delivery Point:</strong> {{contractToCancel.fuelPreference.name}}
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <!-- For awarded locations, only show close button -->
    <div *ngIf="contractToCancel?.currentRound?.status === roundStatuses.AWARDED">
      <button type="button" class="btn btn-primary" (click)="modal.dismiss()">Close</button>
    </div>

    <!-- For non-awarded locations, show normal resume/confirm buttons -->
    <div *ngIf="contractToCancel?.currentRound?.status !== roundStatuses.AWARDED">
      <button type="button" class="btn btn-light me-3" (click)="modal.dismiss()"
        [disabled]="cancellingLocation">Resume</button>
      <button type="button" class="btn btn-danger" (click)="confirmCancelContract()" [disabled]="cancellingLocation">
        <span *ngIf="cancellingLocation">
          <div class="spinner-border spinner-border-sm me-1" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <span>Cancelling...</span>
        </span>
        <span *ngIf="!cancellingLocation">Confirm</span>
      </button>
    </div>
  </div>
</ng-template>

<!-- Delete Location Modal -->
<ng-template #deleteLocationModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Delete Location</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-3">
      Are you sure you want to delete location <strong>{{contractToDelete?.location?.iata}}</strong>?
    </p>
    <div class="alert alert-warning">
      <strong>Warning:</strong> This action cannot be undone. All bids and data associated with this location will be
      permanently removed.
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light me-3" (click)="modal.dismiss()"
      [disabled]="deletingLocation">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="confirmDeleteContract()" [disabled]="deletingLocation">
      <span *ngIf="deletingLocation">
        <div class="spinner-border spinner-border-sm me-1" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <span>Deleting...</span>
      </span>
      <span *ngIf="!deletingLocation">Delete Location</span>
    </button>
  </div>
</ng-template>

<!-- Import Success Modal -->
<div *ngIf="showImportStatsModal"
  class="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center"
  style="z-index: 2000; backdrop-filter: blur(2px);">
  <div class="modal-dialog modal-lg w-100" style="max-width: 500px;">
    <div class="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
      <div class="modal-header bg-success text-white p-4 border-0">
        <div class="d-flex w-100 align-items-center">
          <div class="bg-white bg-opacity-25 rounded-circle p-2 me-3 d-flex align-items-center justify-content-center"
            style="width: 48px; height: 48px;">
            <ng-icon name="lucideCheck" size="24" class="text-white"></ng-icon>
          </div>
          <div>
            <h5 class="modal-title fw-bold fs-4 mb-0">Import Successful!</h5>
            <p *ngIf="!importStats?.import_counts || importStats?.import_counts?.created > 0" class="mb-0 opacity-90 small">Bids have been securely stored.</p>
            <p *ngIf="importStats?.import_counts?.created === 0 && importStats?.import_counts?.merge_skipped > 0" class="mb-0 opacity-90 small">All bids already exist. No changes were made (Merge mode).</p>
          </div>
          <button type="button" class="btn-close btn-close-white ms-auto" (click)="closeImportStatsModal()"></button>
        </div>
      </div>

      <div class="modal-body p-4 bg-light">
        <div class="card border-0 shadow-sm mb-3">
          <div class="card-body p-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-muted fw-bold">Total bids found</span>
              <span class="badge bg-primary rounded-pill px-3 py-2 fs-6">{{ importStats?.total_rows || 0 }}</span>
            </div>
            <div class="progress" style="height: 6px;">
              <div class="progress-bar bg-primary" role="progressbar" style="width: 100%"></div>
            </div>
          </div>
        </div>

        <div class="row g-3">
          <div class="col-6">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body p-3 text-center">
                <div class="display-6 fw-bold text-success mb-1">{{ importStats?.import_counts ? importStats.import_counts.created : (importStats?.locations_imported?.length || 0) }}
                </div>
                <div class="text-muted small fw-bold text-uppercase ls-1">Bids Imported</div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-body p-3 text-center">
                <div class="display-6 fw-bold text-secondary mb-1">{{ importStats?.import_counts ? importStats.import_counts.merge_skipped : (importStats?.locations_skipped?.length || 0) }}
                </div>
                <div class="text-muted small fw-bold text-uppercase ls-1">{{ importStats?.import_counts?.merge_skipped > 0 ? 'Already Existing' : 'Bids Skipped' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer p-3 bg-white border-top-0 justify-content-center">
        <button type="button" class="btn btn-outline-secondary px-5 fw-bold" (click)="closeImportStatsModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>